import { Alert, AlertTitle, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import useAxios from '../../../../hooks/useAxios'
import { EOrderStatus, IOrder } from '../../../../types/order'
import OrderDetailCard from './components/OrderDetailCard'
import OrderProductsListDetailCard from './components/OrderProductsListDetailCard'
import OrderRecipientDetailCard from './components/OrderRecipientDetailCard'
import { ERRORS_MESSAGE_MAPPER } from '../../../../constants/errors'
import { isString } from 'radash'

const Menus: any[] = []

const OrderDetailPage = () => {
  const { id } = useParams()

  const order = useAxios<IOrder>(
    {
      method: 'GET',
      url: `/order/${id}`,
    },
    {
      revalidateOnFocus: false,
    },
  )

  const aiRemark = order.data?.referrer?.aiRemark ?? {}
  const aiSummay = order.data?.referrer?.aiSummary ?? null
  const status = order.data?.status

  return (
    <ContentWrapper>
      <Helmet title="รายการคำสั่งซื้อ" />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายการคำสั่งซื้อ"
            routes={Menus}
            descriptions="รายการคำสั่งซื้อ"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={12}>
          {aiRemark && status === EOrderStatus.AI && (
            <>
              <Alert severity="warning">
                <AlertTitle>ข้อมูลไม่ถูกต้อง</AlertTitle>
                <ul>
                  {Object.keys(aiRemark).map((key) => {
                    const data = aiRemark?.[key]
                    if (key === 'productItemsMissing') {
                      return (
                        <li>
                          <div>ไม่พบสินค้า</div>
                          <ul>
                            {data.map((item: any) => {
                              return (
                                <li>
                                  {item.name} จำนวน {item.quantity ?? 0} ส่วนลด{' '}
                                  {item.quantity ?? 0} ขนาด {item.size || '-'}
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                      )
                    }
                    return (
                      <li>
                        {ERRORS_MESSAGE_MAPPER?.[data] ??
                          (isString(data) ? data : JSON.stringify(data))}
                      </li>
                    )
                  })}
                </ul>
                ** หมายเหตุ รายการแจ้งเตือนเป็นเพียงข้อมูลที่รับจาก AI เท่านั้น
                และจะไม่แสดงหากย้ายไปรายการสินค้า รอส่งแล้ว ***
              </Alert>
            </>
          )}
        </Grid>
        <Grid item xs={12} lg={12}>
          {aiSummay && status === EOrderStatus.AI && (
            <>
              <Alert severity="info">
                <AlertTitle>รายละเอียดคำสั่งซื้อจาก AI</AlertTitle>
                {aiSummay}
              </Alert>
            </>
          )}
        </Grid>
        <Grid item xs={12} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <OrderDetailCard
                isLoading={order.isLoading}
                data={order.data}
                order={order.data as IOrder}
                onSuccess={order.mutate}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <OrderRecipientDetailCard
                isLoading={order.isLoading}
                data={order.data?.recipient}
                order={order.data as IOrder}
                onUpdateAddressListSuccess={order.mutate}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={8}>
          <OrderProductsListDetailCard
            isLoading={order.isLoading}
            onSuccess={order.mutate}
            order={order.data as IOrder}
            data={order.data?.items}
            summary={order.data}
          />
        </Grid>
      </Grid>
    </ContentWrapper>
  )
}

export default OrderDetailPage
